module.exports = __webpack_public_path__ + "img/pdf2.3e889eb3.svg";